import cx from "classnames";
import "./Timer.scss";

export interface TimerElementProps {
  children: number | string;
  unit?: string;
  className?: string;
}

const TimerElement = ({ children, className, unit }: TimerElementProps) => {
  const classes = cx("Timer__element", className);

  // Render

  return (
    <span className={classes}>
      <span className="Timer__element__value" data-unit={unit}>
        {children}
      </span>
    </span>
  );
};

export default TimerElement;
